module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"EXTERNAL_SITE_WARNING":"Dieser Link führt zu einer externen Seite. Möchtest du diese Seite verlassen und zur Seite {siteTitle}?"},"en":{"EXTERNAL_SITE_WARNING":"You are about to leave the website. Do you want to open the external site {siteTitle}?"}}')
  delete Component.options._Ctor
}
